import { useMemo } from "react";
import type { MenuConfig } from "@/config/types";
import { usePartnerInfo } from "./use-partner-info";
import { useSafeTranslations } from "./use-safe-translation";

export default function useMenuConfig() {
	const t = useSafeTranslations();
	// Entitlements, as v1 gated its sidebar (layouts/DefaultLayout.js): the
	// default package hides customers and both report sections, and the card
	// section only exists for partners with the CARDS feature.
	const { hasCardFeature, isDefaultPackage } = usePartnerInfo();

	const menus = useMemo<MenuConfig>(
		() => [
			{
				title: t("menu.dashboard"),
				icon: "dashboard-icon",
				path: "/",
			},
			{
				title: t("menu.toko"),
				icon: "store-icon",
				path: "/store",
			},
			{
				title: t("menu.karyawan"),
				icon: "team-icon",
				path: "/staff",
			},
			{
				title: t("menu.kategori"),
				icon: "bars-icon",
				path: "/category",
			},
			{
				title: t("menu.produk"),
				icon: "inbox-icon",
				path: "/product",
			},
			{
				title: t("menu.inventory.title"),
				icon: "gold-icon",
				children: [
					{
						title: t("menu.inventory.kartu_stok"),
						path: "/inventory/card-stock",
					},
					{
						title: t("menu.inventory.stok_masuk"),
						path: "/inventory/stock-in",
					},
					{
						title: t("menu.inventory.stok_keluar"),
						path: "/inventory/stock-out",
					},
					{
						title: t("menu.inventory.stok_transfer"),
						path: "/inventory/stock-transfer",
					},
					{
						title: t("menu.inventory.penyesuaian_stok"),
						path: "/inventory/stock-adjustment",
					},
				],
			},
			...(isDefaultPackage
				? []
				: ([
						{
							title: t("menu.pelanggan"),
							icon: "idcard-icon",
							path: "/customer",
						},
					] satisfies MenuConfig)),
			{
				title: t("menu.sistem_point"),
				icon: "trophy-icon",
				path: "/system-point",
			},
			...(hasCardFeature
				? ([
						{
							title: t("menu.kartu"),
							icon: "creditCard-icon",
							path: "/card",
						},
					] satisfies MenuConfig)
				: []),
			{
				title: t("menu.promo"),
				icon: "percentage-icon",
				path: "/promo",
			},
			{
				title: t("menu.cazhbox"),
				icon: "database-icon",
				path: "/cazhbox",
			},
			...(isDefaultPackage
				? []
				: ([
						{
							title: t("menu.laporan_offline"),
							icon: "report-icon",
							path: "/report-offline",
						},
						{
							title: t("menu.laporan_online"),
							icon: "report-icon",
							path: "/report-online",
						},
					] satisfies MenuConfig)),
			{
				title: t("menu.supplier"),
				icon: "team-icon",
				path: "/supplier",
			},
			{
				title: t("menu.akun"),
				icon: "setting-icon",
				path: "/account",
			},
		],
		[t, hasCardFeature, isDefaultPackage],
	);

	return menus;
}
